import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store( {
    //数据保存
    state : {
        access_token : '',
        Token:'',
        socket:'',
        typeLists:[]
    },
    mutations : {
        ACCESS_TOKEN ( state, payload ) {
            state.access_token = payload;
        },
        
    }
})
export default store;